import { render, staticRenderFns } from "./Crazetrip.vue?vue&type=template&id=c6d29952&"
import script from "./Crazetrip.vue?vue&type=script&lang=js&"
export * from "./Crazetrip.vue?vue&type=script&lang=js&"
import style0 from "./Crazetrip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports